module.exports = __webpack_public_path__ + "static/img/8.f63ab6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/sp/8.png
// module id = 4DF8
// module chunks = 0